<template>
    <div class="_content">
            <div class="service_tabs" >
                <van-tabs v-model="active" @click="onClickTabs" > 
                    <van-tab title="全部服务">
                        <van-cell 
                            :value= "item.signStatus ? '已开启' : '已关闭' " 
                            :value-class="item.signStatus ? 'service_tabs_list_color' : '' "
                            v-for="(item,index) in shopServiceData" :key="item.secondClassId"
                            :index="item.secondClassId"
                            @click= " handleClick1(tabList1[0],index) "
                            title-class = 'pic_title'
                            :title="item.secondClassName" :label="`结算价￥${item.signPrice} 合计销量 ${item.salesNum} `" 
                            is-link  
                        />
                    </van-tab>

                    <van-tab title="已上线">
                        <van-cell
                            :value= "item.signStatus ? '已开启' : '已关闭' " 
                            :value-class="item.signStatus ? 'service_tabs_list_color' : '' "
                            v-for="(item,index) in serveUplineData" :key="item.secondClassId"
                            :index="item.secondClassId"
                            @click= "handleClick2(tabList1[0],index) "
                            title-class = 'pic_title'
                            :title="item.secondClassName" :label="`结算价￥${item.signPrice} 合计销量 ${item.salesNum} `" 
                            is-link  
                        />
                    </van-tab>

                    <van-tab title="已下线">
                        <van-cell
                            :value= "item.signStatus ? '已开启' : '已关闭' " 
                            :value-class="item.signStatus ? 'service_tabs_list_color' : '' "
                            v-for="(item,index) in serveDownlineData" :key="item.secondClassId"
                            :index="item.secondClassId"
                            @click= "handleClick3(tabList1[0],index)"
                            title-class = 'pic_title'
                            :title="item.secondClassName" :label="`结算价￥${item.signPrice} 合计销量 ${item.salesNum} `" 
                            is-link  
                        />
                    </van-tab>

                </van-tabs>
                <van-button v-call="{tel: (currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848')}" class="shop_service_btn" color="rgb(25,137,250)" size="large" type="info"  ><van-icon name="phone" color="#fff"/> <span>新增服务请联系市场经理</span> </van-button>
            </div>
    </div>
</template>
<script>
import config from '@/configs/config'
export default {
    data() {
        return {
            shopId: '',
            shopServiceData: {},
            serveUplineData: {},
            serveDownlineData: {},
            active: 0,
            tabList1: [{
                name: '关闭服务',
                url: '/pages/shopServeClose/index'
            }],
            clickTabTitle: '',
            clickTabIndex: 0
            // isDisabled: true
        }
    },
    computed: {
        currentShopInfo () {
            return tuhu.store.state.currentShopInfo
        }
    },
    created() {
        this.getServeInfo()
    },
    methods: {
        async getServeInfo() {
            // 权限信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.shopId = roleData.data.shopId
            } else {
                tuhu.toast(roleData.message || '获取权限信息失败')
            }
            // 服务列表
            const data = await tuhu.fetch(`${config.apis.SERVICE_LIST}`, {
                method: 'post',
                body: JSON.stringify({
                    shopId: this.shopId,
                    signStatus: null
                })
            })
            if (data && data.code === '200') {
                this.shopServiceData = data.data
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        },
        // tab切换请求
        async onClickTabs (i, title) {
            this.clickTabTitle = title
            console.log(i, title)
            // if (JSON.stringify(this.serveUplineData) === '{}' && this.clickTabTitle === '已上线' && this.clickTabIndex !== 1) {
            if (this.clickTabTitle === '已上线' && this.clickTabIndex !== 1) {
                // 已上线列表
                const data = await tuhu.fetch(`${config.apis.SERVICE_LIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        shopId: this.shopId,
                        signStatus: 1
                    })
                })
                if (data && data.code === '200') {
                    this.serveUplineData = data.data
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            // } else if (JSON.stringify(this.serveDownlineData) === '{}' && this.clickTabTitle === '已下线' && this.clickTabIndex !== 2) {
            } else if (this.clickTabTitle === '已下线' && this.clickTabIndex !== 2) {
                // 已下线列表
                const data = await tuhu.fetch(`${config.apis.SERVICE_LIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        shopId: this.shopId,
                        signStatus: 0
                    })
                })
                if (data && data.code === '200') {
                    this.serveDownlineData = data.data
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            }
            this.clickTabIndex = i
        },
        handleClick1 (item, index) {
            let i = index
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.shopServiceData[i] || {}
                }
            })
        },
        handleClick2 (item, index) {
            let i = index
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.serveUplineData[i] || {}
                }
            })
        },
        handleClick3 (item, index) {
            let i = index
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.serveDownlineData[i] || {}
                }
            })
        },
        onPageBack () {
			this.getServeInfo()
		}
    }
}
</script>
<style lang="less" scoped>
.service_tabs{
    display: flex;
    flex-direction: column;
    width: 100%;
}
.shop_service_btn{
    width: 16rem;
    height: 2.25rem;
    .van-button__text{
    color: #fff;
        .van-icon {
            font-size: 1rem;
            margin-right: .2rem;
        }
        display:flex;
        justify-content:center;
        align-items:center;
    }
}
.service_tabs_list_color{
    >span{
        color: rgb(25, 137, 250);
    }
}
.van-cell {
    .pic_title{
        >.van-cell__label{
            width: 11rem;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
    .van-icon{
        line-height: 2.3rem;
    }
    .van-cell__value {
        line-height: 2.3rem;
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/shopService/index.vue